/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Store_Google_PlayInputs */

const en_portal_store_google_play = /** @type {(inputs: Portal_Store_Google_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play`)
};

const pl_portal_store_google_play = /** @type {(inputs: Portal_Store_Google_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play`)
};

/**
* | output |
* | --- |
* | "Google Play" |
*
* @param {Portal_Store_Google_PlayInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_store_google_play = /** @type {((inputs?: Portal_Store_Google_PlayInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Store_Google_PlayInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_store_google_play(inputs)
	return en_portal_store_google_play(inputs)
});